<template>
  <div class="login">
    <div class="login-card-opacity"/>
    <div class="login-card">
      <img
        :src="require('@/assets/img/warning-denied.svg')"
        class="logo" >
      <div class="title-denied">Access Denied</div>
      <div class="desc-denied">Sorry you do not have permission.
      Please contact your administrator.</div>
      <b-button
        class="btn-login"
        @click="$router.push('/login')">
        Back to Login Page
      </b-button>
    </div>
    <div class="login-card-copy">
      <p>Version 2.64.5</p>
      <p>Powered by
        <b-link
          href="https://officeless.studio/"
          target="_blank">
          <strong>Jojonomic</strong>
        </b-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JDenied',
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  .login {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../../assets/img/bg-login.png');
    background-size: cover;
    background-position: center;

    &-card {
      width: 464px;
      max-height: 717px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 32px;
      z-index: 999;

      .logo {
        margin-top: 50px;
        width: auto;
        height: 75px;
      }

      .btn-login {
        width: 100%;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $primary-sample;
        font-family: 'Poppins-Medium';
        font-size: 18px;
        color: white;
        border-radius: 10px;
        margin-top: 16px;
        cursor: pointer;

        &:hover {
          background: darken($blue-sample, 20%);
        }
      }
    }

    .title-denied {
      font-family: 'Poppins-Medium';
      font-size: 20px;
      text-align: center;
      color: #787878;
      margin-top: 50px;
    }

    .desc-denied {
      font-family: 'Poppins-Regular';
      font-size: 14px;
      text-align: center;
      color: #787878;
      margin-top: 15px;
    }

    .login-card-copy {
      position: absolute;
      color: white;
      bottom: 10px;
      text-align: center;
      width: 100%;
    }

    .login-card-copy p{
      margin: 10px 0;
      color: #F4F4F4;
      font-size: 11px;
    }

    .login-card-copy p strong{
      font-weight: bold;
      color: white;
    }
  }

  .login-card-opacity {
    width: 506px;
    height: 456px;
    justify-content: center;
    align-items: center;
    border-radius: 12px;
    background: rgba(26, 133, 228, 0.09);
    opacity: 0.7;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/jDenied.vue